import { render, staticRenderFns } from "./search-associates.vue?vue&type=template&id=bc7e2210&"
import script from "./search-associates.vue?vue&type=script&lang=js&"
export * from "./search-associates.vue?vue&type=script&lang=js&"
import style0 from "./search-associates.vue?vue&type=style&index=0&id=bc7e2210&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports